import { ActivityStatusEnum } from '@/modules/marketing/activity/types'

export const ActivityStatusDict = [
  {
    status: ActivityStatusEnum.None,
    name: '未知'
  },
  {
    status: ActivityStatusEnum.Draft,
    name: '未发布'
  },
  {
    status: ActivityStatusEnum.Underway,
    name: '进行中'
  },
  {
    status: ActivityStatusEnum.Ending,
    name: '已结束'
  },
  {
    status: ActivityStatusEnum.Delete,
    name: '已删除'
  },
  {
    status: ActivityStatusEnum.Stopped,
    name: '未发布'
  }
]

export const ActivityStatusFilter = (val: number) => {
  const hit = ActivityStatusDict.find(el => el.status === val)
  return hit ? hit.name : ''
}

export const numberFormat = (val: number) => {
  const def = { value: '0', unit: '' }
  if (!val) return def
  // 0-10000 展示具体数值；10000以上展示两位小数的统计方式 例：1.12万，超过10万展示为10万+
  if (val <= 10000) return { value: `${val}`, unit: '' }
  if (val > 10000) return { value: `${(val / 10000).toFixed(2)}`, unit: '万' }
  if (val > 100000) return { value: `${10}`, unit: '万+' }
  return def
}

export const numberFormatWithUnit = (val: number) => {
  const { value, unit } = numberFormat(val)
  return `${value}${unit}`
}
